import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {Input} from "@angular/core";

export class adminUsersTableCtrl implements IController {
  users: any;
  bindings: any;
  rolesGroups: any;
  queryString: any;
  sortType: any;
  isShowLastActiveColumn: boolean;
  onEdit: Function;
  onEditRoles: Function;
  onRemove: Function;
  onSortChange: Function;

  private rolesMap: any;
  private groupsMap: any;
  private filteredUsers: any;
  public isMobile: boolean;
  public asceDescIconsMap: any;
  public isScrollable: boolean;

  /* @ngInject */
  constructor(private $filter, private $mdMedia) {
  }

  $onInit() {
    this.filteredUsers = this.users ? [...this.users] : [];

    this.asceDescIconsMap = {
      asc: 'sort-asc',
      desc: 'sort-desc',
      undefined: 'sort'
    };

    this._initRolesMap();
    this._initGroupsMap();
  }

  $doCheck() {
    this.isMobile = !this.$mdMedia('gt-sm');
  };

  $onChanges(changes) {

    if (changes.bindings && !changes.bindings.isFirstChange()) {
      this._initRolesMap();
      this._initGroupsMap();
    }

    if (changes.rolesGroups && !changes.rolesGroups.isFirstChange()) {
      this._initGroupsMap();
    }

    if (changes.queryString && !changes.queryString.isFirstChange()) {
      this.filterUsers();
    }

    if (changes.users && !changes.users.isFirstChange()) {
      this.filteredUsers = [...this.users];
    }
  };

  setEvents() {
    const div1 = document.getElementById('admin-users-table').querySelectorAll("#header")[0];
    const div2 = document.getElementById('admin-users-table').querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }


  private _initRolesMap() {
    this.rolesMap = {};

    _.forEach(this.bindings, (binding) => {
      if (!this.rolesMap[binding.memberId]) {
        this.rolesMap[binding.memberId] = [];
      }
      if (binding.roleId) {
        this.rolesMap[binding.memberId].push(binding.roleId);
      }
    });
  }

  private _initGroupsMap() {
    this.groupsMap = {};
    _.forEach(this.bindings, (binding) => {
      if (!this.groupsMap[binding.memberId]) {
        this.groupsMap[binding.memberId] = [];
      }
      if (binding.rolesGroupId) {
        const groupRef = _.find(this.rolesGroups, (g) => {
          return g.id === binding.rolesGroupId;
        })
        if (!!groupRef) {
          this.groupsMap[binding.memberId].push(groupRef);
        }
      }
    });
  }

  private filterUsers() {
    this.filteredUsers = this.users.filter(user => {
      let userCopy = angular.copy(user);
      userCopy.name = this.$filter('userName')(user);
      const query = this.queryString ? this.queryString.toLowerCase() : undefined;
      if (!query) {
        return true;
      }
      return _.includes(JSON.stringify(userCopy).toLowerCase(), query)
    })
  }

}

angular
  .module('bringoz.admin.admins')
  .component('adminUsersTable', {
    bindings: {
      users: '<',
      bindings: '<',
      rolesGroups: '<',
      queryString: '<',
      sortType: '<?',
      isShowLastActiveColumn: '<?',
      onEdit: '&',
      onEditRoles: '&',
      onRemove: '&',
      onSortChange: '&'
    },
    template: require('./admin-users-table.html').default,
    controller: adminUsersTableCtrl
  });
